<template>
  <div
    class="collection-info-section"
    :class="{'--open': isOpen}"
  >
    <div
      class="collection-info-section__head"
      @click="changeOpen"
    >
      <span class="h5 semibold">Дополнительные услуги</span>
      <img src="~/assets/img/svg/common/arrow-down.svg" alt="" />
    </div>
    <div class="collection-info-section__body">
      <div class="services-list">
        <div
          class="service-row-info"
          @click="openModalInfoDelivery"
        >
          <div class="--icon">
            <img src="~/assets/img/svg/common/bonus.svg" alt="" />
          </div>
          <div class="--name h5">Доставка до двери</div>
          <div class="--link">Условия и стоимость</div>
        </div>
        <div
          class="service-row-info"
          @click="openModalInfoAssembly"
        >
          <div class="--icon">
            <img src="~/assets/img/svg/common/assembly.svg" alt="" />
          </div>
          <div class="--name h5">Сборка мебели</div>
          <div class="--link">Условия и стоимость</div>
        </div>
      </div>
    </div>

    <template v-if="modalInfo">
      <teleport to="body">
        <VCupertino
          v-if="modalInfo"
          :is-show="modalInfo"
          :drawer-options="{
          modal: $viewport.isGreaterOrEquals('md'),
          cssClass:'cupertino-modal'
        }"

          @backdropTap="closeModalInfo"
          @didDismiss="closeModalInfo"
        >
          <div class="modal__body-additional">
            <div class="modal-additional-services__title h2">{{ modalInfo.title }}</div>
            <div
              v-if="modalInfo.help"
              class="modal-additional-services__help h5"
              v-html="modalInfo.help"
            />
            <div
              class="modal-additional-services__message h5"
              v-html="modalInfo.value"
            />
          </div>
        </VCupertino>
      </teleport>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { appConfigStore as useAppConfigStore } from '#sitis/stores/modules/app-store';
import VCupertino from '~/components/widget/VCupertino.vue';

const props = defineProps({
  deliveryTabInfo: {
    type: String,
    default: ''
  }
})

const $viewport = useViewport();
const appConfigStore = useAppConfigStore();

const isOpen = ref(true);
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};

const modalInfo: any = ref(null);
const openModalInfoDelivery = () => {
  modalInfo.value = {
    title: 'ДОСТАВКА ДО ДВЕРИ',
    help: props.deliveryTabInfo,
    value: informationDelivery.value
  };
};
const openModalInfoAssembly = () => {
  modalInfo.value = {
    title: 'ПРОФЕССИОНАЛЬНАЯ СБОРКА МЕБЕЛИ',
    value: informationAssembly.value
  };
};
const closeModalInfo = () => {
  modalInfo.value = null;
};

const informationDelivery = computed(() => appConfigStore?.$state?.vars?.['Информация о доставке']);
const informationAssembly = computed(() => appConfigStore?.$state?.vars?.['Информация о сборке']);
</script>

<style lang="scss" scoped>
.services-list {
	display: flex;
	flex-direction: column;

	& > * {
		margin-top: 24px;

		&:first-child {
			margin-top: 0;
		}
	}
}

.service-row-info {
	display: flex;
	align-items: center;

	.--icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		border-radius: 6px;
		background-color: #F5F5F5;
	}

	.--name {
		margin-left: 16px;
		line-height: 100%;
	}

	.--link {
		margin-left: auto;
		cursor: pointer;
		color: #989898;
		font-size: 12px;
		font-weight: 500;
		line-height: 150%;
		text-decoration-line: underline;
		transition: all 0.2s;

		&:hover {
			text-decoration-color: transparent;
		}
	}
}

.modal-additional-services {
}

.modal-additional-services__title {
	margin-bottom: 20px;
}

.modal-additional-services__help {
  margin-bottom: 12px;
}

.modal-additional-services__message {
}

.modal__body-additional {
	padding: 40px;
}

@media (max-width: 860px) {
	.modal__body-additional {
		padding: 20px;
	}
}
</style>
<style lang="scss">
.modal-additional-services__message p {
  margin-bottom: 10px;

  a {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
